import { useApolloClient } from '@vue/apollo-composable'
import { ref } from 'vue'

import LICENSE_STOCK_PHOTO from './licenseStockPhoto.gql'

export interface LicenseStockPhotoResponse {
  licenseStockPhoto: {
    url: string
    license: string
    isLicensed: boolean
  }
}

export interface StockPhotoLicenseInput {
  provider: string
  stockPhotoId: string
}

export function useLicenseStockPhoto() {
  const { client } = useApolloClient()
  const loading = ref(false)
  const error = ref<Error | null>(null)

  const licenseStockPhoto = async (input: StockPhotoLicenseInput) => {
    loading.value = true
    error.value = null

    try {
      const { data } = await client.mutate<LicenseStockPhotoResponse>({
        mutation: LICENSE_STOCK_PHOTO,
        variables: { input },
      })
      if (!data?.licenseStockPhoto?.url) {
        throw new Error('No license image found')
      }
      return data.licenseStockPhoto
    } catch (e) {
      error.value = e as Error
      throw e
    } finally {
      loading.value = false
    }
  }

  return {
    licenseStockPhoto,
    loading,
    error,
  }
}
